module.exports = __webpack_public_path__ + "img/pr-3.caa0a654.png";